import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { AutomationActionsComponent } from './actions.component';
import { AutomationActionDirective } from './actions.directive';
import { SetAttributeActionComponent } from './set-attribute/set-attribute.component';
import { CreateUnderwritingModelActionComponent } from './create-underwriting-model/create-underwriting-model.component';

@NgModule({
  declarations: [
    AutomationActionsComponent,
    AutomationActionDirective,
    SetAttributeActionComponent,
    CreateUnderwritingModelActionComponent,
  ],
  imports: [CommonModule, FormsModule, MatSelectModule],
  exports: [AutomationActionsComponent],
})
export class AutomationActionsModule {}
